import React from 'react';
import { FiRotateCcw } from 'react-icons/fi';

// Одна панель — одно сохранение. title всегда говорит, что именно,
// hint появляется вместо title, когда есть несохранённые правки.
export default function SaveBar({
    dirty,
    onSave,
    onReset,
    label,
    title,
    hint,
    saveDisabled,
    variant = 'bar',
}) {
    const className = [
        'saveBar',
        variant === 'footer' ? 'saveBarFooter' : '',
        variant === 'inline' ? 'saveBarInline' : '',
    ].filter(Boolean).join(' ');

    return (
        <div className={className}>
            <span className={dirty ? 'dirtyHint' : 'saveBarTitle'}>
                {dirty ? hint : title}
            </span>
            <button
                type="button"
                className="modalButton modalButtonCancel"
                onClick={onReset}
                disabled={!dirty}
            >
                <FiRotateCcw style={{ marginRight: '6px', verticalAlign: 'middle' }} />
                Отменить изменения
            </button>
            <button
                type="button"
                className="modalButton modalButtonSave"
                onClick={onSave}
                disabled={!dirty || saveDisabled}
            >
                {label}
            </button>
        </div>
    );
}
